import "tiny-slider/src/tiny-slider";

import "./assets/css/vendor/foundation.css";
import "tiny-slider/dist/tiny-slider.css";
import "basscss.css";



// WEBPACK FOOTER //
// ./src/vendor.js